import { EditableComponent } from '@adobe/aem-react-editable-components';
import clsx from 'clsx';
import { AHeader, AHeaderSize, AHeaderTag } from '@marriott/mi-web-ui-kit';
import { fullbleedClass } from '../../modules/utils/constants/constants';
import { StyledIntroText } from './IntroText.styles';
import { introTextMockData } from './__mock__/IntroText.mock';
import { IntroTextModelProps } from './IntroText.types';

const { NEXT_PUBLIC_AEM_SITE } = process.env;

export const IntroText = ({ styleclass, ...props }: IntroTextModelProps) => {
  const model = props ?? introTextMockData;
  const articleDescription = model?.articleDescription;

  if (!articleDescription) {
    return null;
  }

  return (
    <StyledIntroText
      data-component-name="o-awp-intro-text"
      data-testid="intro-text"
      className={clsx(styleclass, 'my-5')}
    >
      <div
        className={clsx('container intro-text-content', {
          'px-md-0': styleclass?.includes(fullbleedClass),
          'p-0': !styleclass?.includes(fullbleedClass),
        })}
      >
        <AHeader
          text={articleDescription}
          size={model?.aHeader?.size || AHeaderSize.TitleS}
          element={model?.aHeader?.element || AHeaderTag.h2}
          className="intro-text-body"
        />
      </div>
    </StyledIntroText>
  );
};

export const IntroTextConfig = {
  emptyLabel: 'IntroText',
  isEmpty: false,
  resourceType: `${NEXT_PUBLIC_AEM_SITE}/components/content/traveler/introtext`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const IntroTextEditable = (props: any) => (
  <EditableComponent config={IntroTextConfig} {...props}>
    <IntroText {...props} />
  </EditableComponent>
);
